import { render } from "./Chevron.vue?vue&type=template&id=ca517a16&scoped=true"
const script = {}

import "./Chevron.vue?vue&type=style&index=0&id=ca517a16&scoped=true&lang=css"

import exportComponent from "/buddy/openbanking/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca517a16"]])

export default __exports__